// 同期發電量比較
function renderCompareColumnChart ({ type, title, xAxis, series }) {
  return {
    chart: { type },
    title: { text: title },
    tooltip: { valueSuffix: ' kWh' },
    // legend: { enabled: false },
    // yAxis: { showFirstLabel: false }, // y 軸不顯示 0
    plotOptions: {
      [type]: {
        grouping: false, // 設定 false, column 才能重疊
        pointPadding: 0.2
      }
    },
    xAxis,
    series
  }
}

// 每月發電量
function renderSolarAccumulationChart ({ type, title, xAxis, series }) {
  return {
    // chart: { type },
    title: { text: title },
    tooltip: { valueSuffix: ' kWh' },
    xAxis,
    series
  }
}

// 每月減碳量
function renderSolarCarbonReductionChart ({
  type,
  title,
  tooltip = { valueSuffix: ' CO₂e' },
  xAxis,
  series
}) {
  return {
    chart: { type },
    title: { text: title },
    tooltip,
    xAxis,
    series
  }
}

// 每月發電收入
function renderSolarIncomeChart ({
  type,
  title,
  tooltip = { valueSuffix: ' 元' },
  xAxis,
  series
}) {
  return {
    chart: { type },
    title: { text: title },
    tooltip,
    xAxis,
    series
  }
}

// 單體電壓/溫度分布
function renderBmsDistributionChart ({ type, title, xAxis, series }) {
  return {
    chart: { type },
    title: { text: title },
    tooltip: {
      // 加上 時間點 00:00 ....
      // headerFormat: '<div style="font-size:10px">{point.key}555</div>',
      pointFormat:
        '{point.categories} <br/> 電壓: {point.x} v <br/> 溫度: {point.y} °C',
      valueDecimals: 0,
      formatter: function () {
        // <-> way1: 傳入 xAxis 取用, 但下方不設定 xAxis.categories
        // console.log(xAxis)
        // const cat = xAxis.categories?.[this.point.index]
        // <-> way2: userOptions 取出自訂對應的時間, 但在 set 資料要知道設定在哪
        const cat = this.series.userOptions.timeArr?.[this.point.index]
        return `${cat}<br/>電壓: <b>${this.point.x} V</b><br/>溫度: <b>${this.point.y} °C</b>`
      }
    },
    // <-> 不設定 xAxis, x 軸才不會出現時間, 上面的 xAxis 是外部傳入作使用
    // xAxis,
    series
  }
}

// 每月充放電比率
function renderBmsRatioChart ({ type, title, xAxis, series }) {
  return {
    // chart: { type }, // arearange
    title: { text: title },
    xAxis,
    series
  }
}

// 案場建置數量/容量
function renderBmsCapacityChart ({ type, title, xAxis, series }) {
  return {
    chart: { type },
    title: { text: title },
    xAxis,
    series
  }
}

// 每月充放電量
function renderBmsChargeChart ({
  type,
  title,
  tooltip = { valueSuffix: ' kWh' },
  xAxis,
  series
}) {
  return {
    chart: { type },
    title: { text: title },
    tooltip,
    xAxis,
    series
  }
}

// 今日/昨日用電量
function renderPowerConsumptionChart ({
  type,
  title,
  tooltip = { valueSuffix: ' kWh' },
  xAxis,
  series
}) {
  return {
    chart: { type },
    title: { text: title },
    tooltip,
    xAxis,
    series
  }
}

// 電量小時K線圖
function renderPowerHoursChart ({ type, title, xAxis, series }) {
  return {
    chart: { type },
    title: { text: title },
    xAxis,
    series
  }
}

// 本月用電量(日)
function renderPowerDailyChart ({
  type,
  title,
  tooltip = { valueSuffix: ' kWh' },
  xAxis,
  series
}) {
  return {
    chart: { type },
    title: { text: title },
    tooltip,
    xAxis,
    series
  }
}

// 本月累積用電量(日)
function renderPowerAccumulationChart ({ type, title, xAxis, series }) {
  return {
    chart: {
      // type,
      options3d: {
        enabled: true,
        alpha: 10,
        beta: 15,
        depth: 100,
        viewDistance: 50
      }
    },
    title: { text: title },
    tooltip: { valueSuffix: ' kWh' },
    plotOptions: {
      column: {
        depth: 50,
        grouping: false
        // column 有自己的 group 層
        // 線和柱子繪製在同一層，zIndex 才會完全生效
      }
    },
    xAxis,
    yAxis: [
      {
        max: Math.max(...series[0].data) * 1.05,
        labels: { enabled: false }
      },
      {} // 另一個不指定
    ],
    series
  }
}

export const chartRenderers = {
  solarInfo: [
    renderCompareColumnChart,
    renderSolarAccumulationChart,
    renderSolarCarbonReductionChart,
    renderSolarIncomeChart
  ],
  mysqlInfo: [
    renderBmsDistributionChart,
    renderBmsRatioChart,
    renderBmsCapacityChart,
    renderBmsChargeChart
  ],
  powerInfo: [
    renderPowerConsumptionChart,
    renderPowerHoursChart,
    renderPowerDailyChart,
    renderPowerAccumulationChart
  ]
}
